const FILE = {
  UNITS: ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'],
  BASE_VALUE: Array(6).fill(1024)
};
const TIME = {
  UNITS: ['usec', 'ms', 'sec', 'min', 'hour', 'day'],
  BASE_VALUE: [1000, 1000, 60, 60, 24, 1]
};
const NON_CONVERTIBLE_UNITS = ['%'];
const NUMBER = {
  UNITS: ['', 'K', 'M', 'G', 'T', 'P'],
  BASE_VALUE: Array(6).fill(1000)
};

export const isUnitAbleToConvert = (unit) => {
  return [FILE.UNITS, TIME.UNITS].some((item) => item.includes(unit));
};
export const getUnitBaseType = (unit) => {
  if (FILE.UNITS.includes(unit))
    return { type: 'file', units: FILE.UNITS, baseValue: FILE.BASE_VALUE };
  if (TIME.UNITS.includes(unit))
    return { type: 'time', units: TIME.UNITS, baseValue: TIME.BASE_VALUE };
  if (NUMBER.UNITS.includes(unit))
    return { type: 'number', units: NUMBER.UNITS, baseValue: NUMBER.BASE_VALUE };
  throw Error('Unit is not supported to convert');
};

export const convertToHigherUnit = (value, unit) => {
  const { units, baseValue: baseVal } = getUnitBaseType(unit);
  const curIdx = units.indexOf(unit);
  let i = curIdx;
  for (i; i < units.length; i++) {
    if (value < baseVal[i]) break;
    value /= baseVal[i];
  }
  i = Math.min(i, units.length - 1);
  return { value, unit: units[i] };
};

export const convertNumberSymbol = (value, unit) => {
  if (NON_CONVERTIBLE_UNITS.includes(unit)) return { value: value, unit: '' };
  return convertToHigherUnit(value, '');
};

export const convertToSpecificUnit = (value, unit, toUnit) => {
  const { units, baseValue: baseVal } = getUnitBaseType(unit);
  if (!units.includes(toUnit)) throw Error('Converted unit is not valid');
  const curIdx = units.indexOf(unit);
  const toIdx = units.indexOf(toUnit);
  const accumulate = curIdx < toIdx ? baseVal.slice(curIdx, toIdx) : baseVal.slice(toIdx, curIdx);
  const accumulateValue = accumulate.reduce((acc, cur) => acc * cur, 1);
  const newVal = value * Math.pow(accumulateValue, curIdx < toIdx ? -1 : 1);
  return { value: newVal, unit: toUnit };
};

export const convertToSpecificSymbol = (value, unit, toUnit) => {
  if (NON_CONVERTIBLE_UNITS.includes(unit)) return { value: value };
  return convertToSpecificUnit(value, '', toUnit);
};
